var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4 7C8.4 7 12 3.4 13.2 2.2C13.6 1.8 13.6 1.2 13.2 0.8C12.8 0.4 12.2 0.4 11.8 0.8C10.6 2 7 5.6 7 5.6C7 5.6 3.4 2 2.2 0.8C1.8 0.4 1.2 0.4 0.8 0.8C0.4 1.2 0.4 1.8 0.8 2.2C2 3.4 5.6 7 5.6 7C5.6 7 2 10.6 0.8 11.8C0.4 12.2 0.4 12.8 0.8 13.2C1.2 13.6 1.8 13.6 2.2 13.2C3.4 12 7 8.4 7 8.4C7 8.4 10.6 12 11.8 13.2C12.2 13.6 12.8 13.6 13.2 13.2C13.6 12.8 13.6 12.2 13.2 11.8C12 10.6 8.4 7 8.4 7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.7ad4ae1f58098c4db3f0ac7491d3701a.svg";
export { ForwardRef as ReactComponent };